/* Back Seat Mount product page (bsm-*). Loaded with defer by each bsm section; runs once.
   Frame sets: numbered theme files (…-0001.webp …), loaded coarse-to-fine (every 8th frame, then 4th, 2nd, all),
   nearest the current angle first, a few requests at a time and only after the stage is near the screen. In the
   360 viewer the other views then load in the background so switching is instant. Until a frame set exists the
   sections fall back to their still pictures. */
(function () {
  if (window.bsmPdpLoaded) return;
  window.bsmPdpLoaded = true;

  var pad = function (n) { return String(n).padStart(4, '0'); };
  /* Frame URLs from the first file's asset URL (…-0001.webp?v=…). */
  function frameUrls(base, count) {
    var m = base && base.match(/^(.*?)(\d{4})(\.[a-z0-9]+)(\?.*)?$/i);
    if (!m || count < 2) return null;
    var urls = [];
    for (var n = 1; n <= count; n++) urls.push(m[1] + pad(n) + m[3] + (m[4] || ''));
    return urls;
  }
  /* Same frame engine as the Impact Armour Pro hero (window.IAPFrameSet from iap-scroll-story.js): coarse to fine,
     nearest the current frame first, bounded concurrency shared across sets, decode-ahead. */
  function engine() { return window.IAPFrameSet || null; }
  /* Backing store = one frame; CSS object-fit crops it (as the IAP viewer does). */
  function drawFrame(canvas, ctx, image) {
    if (canvas.width !== image.naturalWidth || canvas.height !== image.naturalHeight) { canvas.width = image.naturalWidth; canvas.height = image.naturalHeight; }
    ctx.drawImage(image, 0, 0);
  }
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '300px' });
    io.observe(el);
  }

  /* 360° viewer in the product section. Same structure as the Impact Armour Pro hero viewer (iap-product.js):
     viewerSet / warmViewers / prefetchAngles / drawViewer / maybeSpin, with views instead of colours. */
  class BsmViewer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.views = Array.from(this.querySelectorAll('[data-bsm-view]'));
      this.pills = Array.from(this.querySelectorAll('[data-bsm-pick]'));
      this.canvas = this.querySelector('[data-bsm-canvas]');
      this.ctx = this.canvas.getContext('2d');
      this.slider = this.querySelector('[data-bsm-angle]');
      this.rotate = this.querySelector('[data-bsm-rotate]');
      this.stage = this.querySelector('[data-bsm-stage]');
      this.introTo = parseInt(this.dataset.intro, 10) || 0;
      this.current = 0;
      this.frame = 0;
      this.spun = false;
      this.viewerNear = false;
      this.viewerVisible = false;
      this.pageReady = document.readyState === 'complete';
      this.urls = this.views.map(function (v) { return frameUrls(v.dataset.frameBase, parseInt(v.dataset.frameCount, 10) || 0); });
      this.sets = [];
      this.angleImages = new Map();
      this.pills.forEach(function (b) { b.addEventListener('click', function () { self.spun = true; self.stopSpin(); self.pick(parseInt(b.dataset.bsmPick, 10)); }); });
      this.slider.addEventListener('input', function () { self.spun = true; self.stopSpin(); self.setFrame(Math.round(parseInt(self.slider.value, 10) / 360 * self.count())); });
      this.stage.addEventListener('pointerdown', function (e) {
        if (!self.urls[self.current] || e.target.closest('button')) return;
        self.spun = true; self.stopSpin();
        self.drag = { x: e.clientX, frame: self.frame };
        self.classList.add('is-dragging');
        try { self.stage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      /* Drag right = slider right (Parth, 24 Oct 2026), as on the Impact Armour Pro hero. */
      this.stage.addEventListener('pointermove', function (e) {
        if (!self.drag) return;
        self.setFrame(Math.round(self.drag.frame + (e.clientX - self.drag.x) / (600 / self.count())));
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) {
        self.stage.addEventListener(n, function () { self.drag = null; self.classList.remove('is-dragging'); });
      });
      if (!this.pageReady) {
        var ready = function () { if (self.pageReady) return; self.pageReady = true; if (self.activeSet) self.activeSet.pump(); self.warmViewers(); };
        window.addEventListener('load', ready, { once: true });
        setTimeout(ready, 2000);
      }
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) {
          self.viewerNear = es.some(function (e) { return e.isIntersecting; });
          if (self.viewerNear) { self.pick(self.current, true); self.warmViewers(); }
          else { self.stopSpin(); self.sets.forEach(function (s) { if (s) s.pause(); }); }
        }, { rootMargin: '250px' });
        this.io.observe(this.stage);
        this.spinIo = new IntersectionObserver(function (es) {
          self.viewerVisible = es.some(function (e) { return e.isIntersecting && e.intersectionRatio >= .35; });
          if (self.viewerVisible) self.maybeSpin();
        }, { threshold: [0, .35] });
        this.spinIo.observe(this.stage);
      } else { this.viewerNear = this.viewerVisible = true; }
      this.pick(0, true);
      this.packCards();
    }
    packCards() {
      var data = this.querySelector('[data-bsm-packs]'), map;
      try { map = JSON.parse(data.textContent); } catch (err) { return; }
      var main = this.closest('.shopify-section--main-product') || document;
      main.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var info = map[input.value], label = input.id && main.querySelector('label[for="' + input.id + '"]');
        if (!info || !label || label.querySelector('.bsm-pack-card__price')) return;
        label.classList.add('bsm-pack-card');
        label.parentElement.classList.add('bsm-pack-cards');
        if (info.tag) label.insertAdjacentHTML('beforeend', '<span class="bsm-pack-card__tag"></span>');
        label.insertAdjacentHTML('beforeend', '<span class="bsm-pack-card__price"></span>' + (info.note ? '<span class="bsm-pack-card__note"></span>' : ''));
        if (info.tag) label.querySelector('.bsm-pack-card__tag').textContent = info.tag;
        label.querySelector('.bsm-pack-card__price').textContent = info.price;
        if (info.was) { var was = document.createElement('s'); was.className = 'bsm-pack-card__was'; was.textContent = info.was; label.querySelector('.bsm-pack-card__price').appendChild(was); }
        if (info.note) label.querySelector('.bsm-pack-card__note').textContent = info.note.replace(/₹\s+/g, '₹\u00a0').replace(/save\s+/g, 'save\u00a0');
      });
    }
    count(i) { var u = this.urls[i == null ? this.current : i]; return u ? u.length : 60; }
    index(i) { var n = this.count(i); return ((this.frame % n) + n) % n; }
    viewerSet(i) {
      var Engine = engine(), urls = this.urls[i];
      if (!Engine || !urls) return null;
      var set = this.sets[i];
      if (!set) {
        var self = this;
        set = new Engine(urls, { limit: 12, near: 6, ahead: 4, circular: true, gate: function () { return self.pageReady ? 2 : 0; }, onLoad: function () {
          if (!self.isConnected) return;
          if (set === self.activeSet) { self.drawViewer(); self.maybeSpin(); }
          else if (self.activeSet && !self.activeSet.complete) self.activeSet.pump();
          self.warmViewers();
        } });
        urls.forEach(function (url, k) { var im = self.angleImages.get(url); if (im) set.adopt(k, im); });
        this.sets[i] = set;
      }
      return set;
    }
    pick(i, quiet) {
      this.current = i;
      this.views.forEach(function (v, k) { v.classList.toggle('is-active', k === i); });
      this.pills.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      var urls = this.urls[i];
      this.classList.toggle('is-spinnable', !!urls);
      this.rotate.hidden = !urls;
      if (!urls) { this.classList.remove('has-frames'); this.activeSet = null; return; }
      if (!this.viewerNear) { this.drawViewer(); return; }
      var set = this.viewerSet(i);
      if (!set) return;
      /* A newly selected view must not wait behind background warm-ups (same fix as the IAP hero, 19 Sep). */
      if (this.activeSet !== set) this.sets.forEach(function (s) { if (s && s !== set) s.pause(); });
      set.limit = 12;
      this.activeSet = set;
      set.seek(this.index(i), 1);
      this.drawViewer();
      this.warmViewers();
      if (!quiet) this.prefetchAngles(this.index(i) + 1);
    }
    warmViewers() {
      /* Once the selected view is fully in, fetch the other views at low concurrency so switching is instant at any angle. */
      if (!this.viewerNear || !this.activeSet || !this.activeSet.complete || !this.pageReady) return;
      if (navigator.connection && navigator.connection.saveData) return;
      for (var i = 0; i < this.urls.length; i++) {
        if (i === this.current || !this.urls[i]) continue;
        var set = this.viewerSet(i);
        if (!set || set.complete) continue;
        if (!set.active) { set.limit = 8; set.seek(this.index(i), 1); }
        return; /* one background set at a time */
      }
    }
    prefetchAngles(n) {
      /* Keep the other views ready at the exact selected angle without loading every set. */
      var self = this;
      this.urls.forEach(function (urls, i) {
        if (!urls || i === self.current) return;
        var url = urls[((n - 1) % urls.length + urls.length) % urls.length];
        if (self.angleImages.has(url)) return;
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { var set = self.sets[i]; var k = urls.indexOf(url); if (set && !set.images[k] && !set.inflight.has(k)) set.adopt(k, im); };
        im.src = url;
        self.angleImages.set(url, im);
        if (self.angleImages.size > 24) self.angleImages.delete(self.angleImages.keys().next().value);
      });
    }
    setFrame(f) {
      this.frame = f;
      var n = this.count(), idx = this.index();
      var deg = Math.round(idx / n * 360) % 360;
      this.slider.value = String(deg);
      this.slider.style.setProperty('--bsm-fill', (deg / 359 * 100) + '%');
      this.slider.setAttribute('aria-valuetext', deg + ' degrees');
      if (this.activeSet) this.activeSet.seek(idx, 1);
      this.drawViewer();
      var self = this;
      clearTimeout(this.angleTimer);
      if (!this.spinState) this.angleTimer = setTimeout(function () { self.prefetchAngles(idx + 1); }, 250);
    }
    drawViewer() {
      var set = this.activeSet;
      if (!set) return;
      var ready = set.nearest(this.index());
      /* never show another view's frame: this view's frame or a close neighbour, else its still picture */
      var n = this.count(), off = ready ? Math.abs(ready.index - this.index()) : n;
      if (!ready || Math.min(off, n - off) > 6) { this.classList.remove('has-frames'); return; }
      drawFrame(this.canvas, this.ctx, ready.image);
      this.classList.add('has-frames');
    }
    maybeSpin() {
      if (this.spun || !this.viewerVisible || !this.introTo || this.current !== 0) return;
      /* The one-time intro turn only plays from a complete set, so it is never choppy (as on the IAP hero). */
      if (!this.activeSet || !this.activeSet.complete) return;
      this.spun = true;
      this.spin(Math.round(this.introTo / 360 * this.count()));
    }
    spin(steps) {
      var self = this;
      this.spinState = { from: this.frame, step: 0, last: performance.now() };
      var tick = function (t) {
        var st = self.spinState;
        if (!st || !self.isConnected) return;
        if (t - st.last >= 40) {
          var raw = st.from + st.step + 1, n = self.count(), idx = ((raw % n) + n) % n;
          if (self.activeSet && self.activeSet.images[idx]) {
            st.step++; st.last = t; self.setFrame(raw);
            if (st.step >= steps) { self.stopSpin(); self.prefetchAngles(idx + 1); return; }
          }
        }
        self.spinRaf = requestAnimationFrame(tick);
      };
      this.spinRaf = requestAnimationFrame(tick);
    }
    stopSpin() { if (this.spinRaf) cancelAnimationFrame(this.spinRaf); this.spinRaf = 0; this.spinState = null; }
    disconnectedCallback() {
      this.stopSpin(); clearTimeout(this.angleTimer);
      if (this.io) this.io.disconnect(); if (this.spinIo) this.spinIo.disconnect();
      this.sets.forEach(function (s) { if (s) s.destroy(); }); this.sets = []; this.angleImages.clear(); this.ready = false;
    }
  }

  /* Two-state pictures: buttons (toggle) or a slider; plays a frame sequence when one is set. Slider mode with frames
     (exploded head, 24 Oct 2026) behaves like the hero: same engine, drag right = slider right, one play on arrival from
     the start to data-intro % (only from a complete set, 40 ms a frame), stopped by any drag or slide. */
  class BsmSequence extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.mode = this.dataset.mode;
      this.states = Array.from(this.querySelectorAll('[data-bsm-state]'));
      this.copies = Array.from(this.querySelectorAll('[data-bsm-copy]'));
      this.pills = Array.from(this.querySelectorAll('[data-bsm-pick]'));
      this.canvas = this.querySelector('[data-bsm-canvas]');
      this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
      var urls = this.canvas && frameUrls(this.dataset.frameBase, parseInt(this.dataset.frameCount, 10) || 0), Engine = engine();
      this.set = urls && Engine ? new Engine(urls, { limit: 12, near: 6, ahead: 4, circular: false, onLoad: function () { self.draw(); self.maybePlay(); } }) : null;
      this.pos = 0;
      this.introTo = (parseInt(this.dataset.intro, 10) || 0) / 100;
      this.spun = !this.introTo;
      this.visible = false;
      this.pills.forEach(function (b) { b.addEventListener('click', function () { self.go(parseInt(b.dataset.bsmPick, 10)); }); });
      this.slider = this.querySelector('[data-bsm-slider]');
      if (this.slider) {
        this.slider.addEventListener('input', function () { self.interact(); self.scrub(parseInt(self.slider.value, 10) / 100); });
        this.scrub(parseInt(this.slider.value, 10) / 100);
      }
      if (this.set) {
        whenNear(this, function () { self.set.seek(self.frameIndex(), 1); });
        if ('IntersectionObserver' in window) {
          this.spinIo = new IntersectionObserver(function (es) {
            self.visible = es.some(function (e) { return e.isIntersecting && e.intersectionRatio >= .35; });
            if (self.visible) self.maybePlay();
          }, { threshold: [0, .35] });
          this.spinIo.observe(this);
        }
      }
      var media = this.dataset.drag && this.querySelector('.bsm-explode__media');
      if (media && this.set) {
        media.addEventListener('pointerdown', function (e) {
          self.interact();
          self.drag = { x: e.clientX, pos: self.pos, w: media.clientWidth || 300 };
          self.classList.add('is-dragging');
          try { media.setPointerCapture(e.pointerId); } catch (err) {}
        });
        media.addEventListener('pointermove', function (e) {
          if (!self.drag) return;
          self.scrub(Math.max(0, Math.min(1, self.drag.pos + (e.clientX - self.drag.x) / (self.drag.w * 1.5))));
        });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) {
          media.addEventListener(n, function () { self.drag = null; self.classList.remove('is-dragging'); });
        });
      }
    }
    interact() { this.spun = true; this.stopPlay(); }
    go(i) {
      var self = this;
      this.pills.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      this.copies.forEach(function (c, k) { c.hidden = k !== i; });
      if (!this.set || !this.set.loadedCount) {
        this.states.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        return;
      }
      var from = this.pos, to = i === 0 ? 0 : 1, t0 = performance.now(), dur = 900;
      cancelAnimationFrame(this.raf);
      var step = function (now) {
        var p = Math.min(1, (now - t0) / dur), e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        self.pos = from + (to - from) * e;
        self.draw();
        if (p < 1) self.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }
    scrub(v) {
      this.pos = v;
      if (this.slider) {
        this.slider.value = String(Math.round(v * 100));
        this.slider.style.setProperty('--bsm-fill', (v * 100) + '%');
      }
      if (this.set) { if (this.set.active) this.set.seek(this.frameIndex(), 1); this.draw(); return; }
      if (this.states.length > 1) {
        this.states[0].style.opacity = String(1 - v);
        this.states[1].style.opacity = String(v);
        this.states[1].classList.add('is-active');
      }
    }
    maybePlay() {
      if (this.spun || !this.visible || !this.set || !this.set.complete) return;
      this.spun = true;
      var self = this, last = Math.round(this.introTo * (this.set.n - 1)), i = this.frameIndex(), t0 = performance.now();
      var tick = function (t) {
        if (t - t0 >= 40) { t0 = t; i++; self.scrub(i / (self.set.n - 1)); if (i >= last) { self.stopPlay(); return; } }
        self.playRaf = requestAnimationFrame(tick);
      };
      this.playRaf = requestAnimationFrame(tick);
    }
    stopPlay() { if (this.playRaf) cancelAnimationFrame(this.playRaf); this.playRaf = 0; }
    frameIndex() { return Math.round(this.pos * (this.set.n - 1)); }
    draw() {
      if (!this.set) return;
      var ready = this.set.nearest(this.frameIndex());
      if (!ready) return;
      drawFrame(this.canvas, this.ctx, ready.image);
      this.classList.add('has-frames');
    }
  }

  /* Tabs (device section) */
  class BsmTabs extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.pick(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + self.tabs.length) % self.tabs.length;
          self.pick(n);
          self.tabs[n].focus();
        });
      });
    }
    pick(i) {
      this.tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      this.querySelectorAll('[data-bsm-copy]').forEach(function (c, k) { c.hidden = k !== i; });
      this.querySelectorAll('[role="tabpanel"]').forEach(function (p, k) { p.hidden = k !== i; });
    }
  }

  /* Videos with play/pause, progress and an optional "play all" */
  class BsmVideos extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var self = this;
      this.items = Array.from(this.querySelectorAll('[data-bsm-video]')).map(function (v) {
        var media = v.parentElement;
        var item = { v: v, btn: media.querySelector('[data-bsm-play]'), bar: media.querySelector('[data-bsm-prog]') };
        v.addEventListener('timeupdate', function () { if (item.bar && v.duration) item.bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
        v.addEventListener('play', function () { self.sync(); });
        v.addEventListener('pause', function () { self.sync(); });
        if (item.btn) item.btn.addEventListener('click', function () {
          self.stopSequence();
          if (v.paused) { item.userPaused = false; v.play().catch(function () {}); } else { item.userPaused = true; v.pause(); }
        });
        return item;
      });
      /* data-bsm-autoplay: play (muted, looped) while at least 40% is on screen, pause when scrolled away; a tap on
         pause is respected until the shopper taps play again. Not tied to the OS Reduce Motion setting (the
         section's own "play by itself" checkbox is the switch). */
      var auto = this.items.filter(function (it) { return it.v.hasAttribute('data-bsm-autoplay'); });
      if (auto.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var it = auto.find(function (a) { return a.v === e.target; });
            if (!it) return;
            if (e.isIntersecting && e.intersectionRatio >= 0.4) { if (!it.userPaused) { it.v.muted = true; it.v.play().catch(function () {}); } }
            else if (!it.v.paused) it.v.pause();
          });
        }, { threshold: [0, 0.4] });
        auto.forEach(function (it) { io.observe(it.v); });
      }
      /* Lazy covers: a video's poster is fetched only when it is within 300px of the screen (the video itself is preload="none"). */
      var lazy = this.items.filter(function (it) { return it.v.dataset.poster; });
      if (lazy.length) whenNear(this, function () { lazy.forEach(function (it) { it.v.poster = it.v.dataset.poster; }); });
      if (this.dataset.sequence) this.setupSequence();
      this.all = this.querySelector('[data-bsm-all]');
      if (this.all) this.all.addEventListener('click', function () {
        self.stopSequence();
        var playing = self.items.every(function (it) { return !it.v.paused; });
        self.items.forEach(function (it) { if (playing) it.v.pause(); else it.v.play().catch(function () {}); });
      });
    }
    /* One after another (setup row, 24 Oct 2026): while the row is ≥40% on screen, play card i once (muted, no loop), then i+1,
       wrapping to the first; pause when scrolled away and resume the same card on return. Any play/pause or Play-all tap ends it. */
    setupSequence() {
      var self = this;
      this.seq = { on: true, i: 0 };
      this.items.forEach(function (it, k) {
        it.v.loop = false;
        it.v.addEventListener('ended', function () { if (self.seq && self.seq.on && k === self.seq.i) self.playSeq((k + 1) % self.items.length, true); });
      });
      if (!('IntersectionObserver' in window)) return;
      this.seqIo = new IntersectionObserver(function (es) {
        if (!self.seq || !self.seq.on) return;
        var vis = es.some(function (e) { return e.isIntersecting && e.intersectionRatio >= .4; });
        if (vis) self.playSeq(self.seq.i, false);
        else self.items.forEach(function (it) { if (!it.v.paused) it.v.pause(); });
      }, { threshold: [0, .4] });
      this.seqIo.observe(this.querySelector('.bsm-rail') || this);
    }
    playSeq(i, fromStart) {
      this.seq.i = i;
      this.items.forEach(function (it, k) {
        it.v.closest('.bsm-step') && it.v.closest('.bsm-step').classList.toggle('is-current', k === i);
        if (k !== i && !it.v.paused) it.v.pause();
      });
      var v = this.items[i].v;
      v.muted = true;
      if (fromStart) v.currentTime = 0;
      v.play().catch(function () {});
      /* Bring the playing card into view inside the swipe row (phones), without moving the page itself. */
      var rail = this.querySelector('.bsm-rail'), card = v.closest('.bsm-step');
      if (rail && card && rail.scrollWidth > rail.clientWidth + 2) {
        var left = rail.scrollLeft + card.getBoundingClientRect().left - rail.getBoundingClientRect().left;
        rail.scrollTo({ left: Math.max(0, Math.min(left, rail.scrollWidth - rail.clientWidth)), behavior: 'smooth' });
      }
    }
    stopSequence() {
      if (!this.seq || !this.seq.on) return;
      this.seq.on = false;
      if (this.seqIo) this.seqIo.disconnect();
      this.items.forEach(function (it) {
        it.v.loop = true;
        var card = it.v.closest('.bsm-step'); if (card) card.classList.remove('is-current');
      });
    }
    sync() {
      this.items.forEach(function (it) {
        if (!it.btn) return;
        var on = !it.v.paused;
        it.btn.classList.toggle('is-playing', on);
        it.btn.setAttribute('aria-label', on ? it.btn.dataset.labelPause : it.btn.dataset.labelPlay);
      });
      if (this.all) {
        var all = this.items.length > 0 && this.items.every(function (it) { return !it.v.paused; });
        this.all.setAttribute('aria-pressed', all ? 'true' : 'false');
        this.all.textContent = all ? this.all.dataset.labelPause : this.all.dataset.labelPlay;
      }
    }
  }

  if (!customElements.get('bsm-viewer')) customElements.define('bsm-viewer', BsmViewer);
  if (!customElements.get('bsm-sequence')) customElements.define('bsm-sequence', BsmSequence);
  if (!customElements.get('bsm-tabs')) customElements.define('bsm-tabs', BsmTabs);
  if (!customElements.get('bsm-videos')) customElements.define('bsm-videos', BsmVideos);

  /* "Choose Pack of 2": pick that value in the product section's variant picker, then scroll up to it */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-bsm-pick-variant]');
    if (!link) return;
    var value = link.dataset.bsmPickVariant;
    var main = document.querySelector('.shopify-section--main-product');
    if (!main) return;
    var input = Array.from(main.querySelectorAll('input[type="radio"]')).find(function (r) { return r.value === value; });
    var select = !input && Array.from(main.querySelectorAll('select option')).find(function (o) { return o.value === value; });
    /* Quantity packs (24 Oct 2026): no pack variant → press the quantity selector's button for that quantity */
    var qtyBtn = !input && !select && link.dataset.bsmPickQty && main.querySelector('quantity-selector-pack [data-qty="' + link.dataset.bsmPickQty + '"]');
    if (qtyBtn) { e.preventDefault(); qtyBtn.click(); window.scrollTo({ top: Math.max(0, main.getBoundingClientRect().top + window.scrollY - 80), behavior: 'smooth' }); return; }
    if (!input && !select) return;
    e.preventDefault();
    if (input) { if (!input.checked) input.click(); }
    else { select.parentElement.value = value; select.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
    window.scrollTo({ top: Math.max(0, main.getBoundingClientRect().top + window.scrollY - 80), behavior: 'smooth' });
  });
})();
